import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';
import { AreaChart, Area, ResponsiveContainer } from 'recharts';
import { formatCurrency, formatPercent, getPnLColor } from '../../utils/formatters';

/**
 * PortfolioHero — Displays portfolio value, P&L, and 30-day sparkline.
 */
const PortfolioHero = ({ totalValue, totalInvested, todayPnL, todayPnLPercent, positionsCount, sparklineData }) => {
  const pnlColor = getPnLColor(todayPnL);
  const chartColor = todayPnL >= 0 ? '#3fb950' : '#f85149';

  // Convert sparkline array to recharts data format
  const chartData = sparklineData
    ? sparklineData.map((value, index) => ({ index, value }))
    : null;

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent sx={{ py: 3, px: 3.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 4, flexWrap: 'wrap' }}>
          {/* Portfolio Info */}
          <Box sx={{ flex: 1, minWidth: 200 }}>
            <Typography
              variant="h3"
              sx={{ fontWeight: 800, fontSize: { xs: '1.8rem', md: '2.4rem' }, mb: 0.5 }}
            >
              {formatCurrency(totalValue)}
            </Typography>
            <Typography
              variant="body1"
              sx={{ fontWeight: 600, color: pnlColor, mb: 1.5 }}
            >
              {todayPnL >= 0 ? '+' : ''}{formatCurrency(todayPnL)} ({formatPercent(todayPnLPercent)}) today
            </Typography>
            <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
              <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: 13 }}>
                💼 {positionsCount} positions
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: 13 }}>
                📈 Invested: {formatCurrency(totalInvested)}
              </Typography>
            </Box>
          </Box>

          {/* Sparkline */}
          {chartData && (
            <Box sx={{ width: { xs: '100%', md: 280 }, height: 80 }}>
              <ResponsiveContainer width="100%" height="100%">
                <AreaChart data={chartData} margin={{ top: 5, right: 0, left: 0, bottom: 0 }}>
                  <defs>
                    <linearGradient id="sparklineGradient" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="0%" stopColor={chartColor} stopOpacity={0.3} />
                      <stop offset="100%" stopColor={chartColor} stopOpacity={0} />
                    </linearGradient>
                  </defs>
                  <Area
                    type="monotone"
                    dataKey="value"
                    stroke={chartColor}
                    strokeWidth={2}
                    fill="url(#sparklineGradient)"
                    dot={false}
                    isAnimationActive={false}
                  />
                </AreaChart>
              </ResponsiveContainer>
            </Box>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default PortfolioHero;
